export function scrollToElemById(id:string) {
  const elem = document.getElementById(id);
  if (elem === null) {
      return;
  }
  
  elem.scrollIntoView({
    behavior: 'smooth'
  });
}


// WEBPACK FOOTER //
// ./src/components/utils/Scroller.ts